export const getContactMethods = (state) => state.contactMethods.data;
export const getCreateContactMethodsApi = (state) => state.contactMethods.createApi;
export const getFetchContactMethodsApi = (state) => state.contactMethods.fetchApi;
export const getUpdateContactMethodsApi = (state) => state.contactMethods.updateApi;
export const getDeleteContactMethodsApi = (state) => state.contactMethods.deleteApi;
